import {
  DEFAULT_ANNOTATIONS_DIMENSIONS,
  TRACK_SEPARATOR_STROKE_WIDTH,
  type AnnotationsDimensions,
} from '../constants.js';

export const getAnnotationsTracksHeight = (
  tracksCount: number,
  dimensions: AnnotationsDimensions = DEFAULT_ANNOTATIONS_DIMENSIONS,
): number => {
  if (tracksCount > 0) {
    return tracksCount * dimensions.trackHeight + TRACK_SEPARATOR_STROKE_WIDTH;
  }

  return 0;
};
